import { render, staticRenderFns } from "./SquareNode.vue?vue&type=template&id=3e80585b&"
import script from "./SquareNode.vue?vue&type=script&lang=js&"
export * from "./SquareNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports